










































































































































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import VueFileAgentPlugin, { FileRecord } from "vue-file-agent";
import { VueFileAgentComponent } from "../../../interfaces/vueFileAgent";
import { PlyrSource, Stream } from "../../../interfaces/plyrSources";
import { PlyrConfiguration } from "./plyrConfiguration";
import { FileService } from "../../../services/fileService";
import ConfirmDeleteDialog from "@/components/customActions/ConfirmDeleteDialog.vue";

@Component({
    components: {
        "vue-file-agent": VueFileAgentPlugin.VueFileAgent,
        ConfirmDeleteDialog,
    },
})
export default class PlyrUploadScreen extends Vue {
    @Prop() config!: PlyrConfiguration;

    public fileRecords: FileRecord[] = [];
    public token: string = "";
    public fileRecordsForUpload: FileRecord[] = [];
    public showUploadError: boolean = false;
    public sources: PlyrSource[] = [];
    public videoSizes: string[] = ["480p", "720p", "1080p"];
    public videoTitle: string = "";
    public formOptions: string = "upload";
    public existingItems: Stream[] = [];
    public selectedItem: Stream | null = null;
    public videoOrAudio: string = "video";
    public deleteDialogActive: boolean = false;
    public fileRecordToDelete: FileRecord | null = null;

    public get uploadHeaders() {
        return { Authorization: `Bearer ${this.token}` };
    }

    public get uploadUrl(): string {
        return "/api/file/by_id/" + this.config.widgetId;
    }

    public get agent() {
        return (this.$refs.vueFileAgent as unknown) as VueFileAgentComponent;
    }
    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || this.$t("widget.plyr.enterTitle").toString(),
            notEmpty: v =>
                v.length > 0 || this.$t("widget.plyr.enterTitle").toString(),
        };
    }

    public get descriptions(): {
        hint?: string;
        uploadText: string;
        accept: string;
    } {
        if (this.videoOrAudio == "video") {
            return {
                hint: "widget.plyr.uploadInstructionsVideo",
                uploadText: "widget.plyr.uploadHintVideo",
                accept: ".mp4, .webm",
            };
        } else
            return {
                uploadText: "widget.plyr.uploadHintAudio",
                accept: ".mp3, .ogg, .flac",
            };
    }

    public async mounted() {
        if (this.$auth.isAuthenticated) {
            this.token = await this.$auth.getTokenSilently();
            this.existingItems = await FileService.getStreams(this.token);
            this.existingItems.forEach(
                item =>
                    (item.videoTitle = this.$t(
                        "widget.plyr.mediaSelectItemText",
                        {
                            videoTitle: item.videoTitle,
                            script: item.scriptName,
                            page: item.pageNumber,
                        }
                    ).toString())
            );
        }
    }
    public validate() {
        return (this.$refs.form as Vue & {
            validate: () => boolean;
        }).validate();
    }
    @Emit() uploadDone(validate: boolean) {
        if (validate) {
            if (this.validate()) {
                return { sources: this.sources, videoTitle: this.videoTitle };
            }
        } else {
            this.sources = this.selectedItem?.sources || [];
            this.videoTitle = this.selectedItem?.videoTitle || "";
            return { sources: this.sources, videoTitle: this.videoTitle };
        }
    }
    public uploadFiles() {
        // Using the default uploader. You may use another uploader instead.
        this.agent.upload(
            this.uploadUrl,
            this.uploadHeaders,
            this.fileRecordsForUpload
        );

        this.fileRecordsForUpload = [];
    }
    public deleteUploadedFile(fileRecord: FileRecord) {
        const uploadData = { someFileId: "123" };
        // remove file record from source array
        if (fileRecord.upload.data) {
            const i = this.sources
                .map(s => {
                    return s.src;
                })
                .indexOf("/api/file/stream/by_id/" + fileRecord.upload.data.id);
            if (i !== -1) {
                this.sources.splice(i, 1);
            }
        }

        this.agent.deleteUpload(
            fileRecord.urlValue || "",
            this.uploadHeaders,
            fileRecord,
            uploadData
        );
    }
    public filesSelected(fileRecordsNewlySelected: FileRecord[]) {
        const validFileRecords = fileRecordsNewlySelected.filter(
            fileRecord =>
                !fileRecord.error &&
                (this.videoSizes.some(name =>
                    fileRecord
                        .name()
                        .toString()
                        .includes(name)
                ) ||
                    this.videoOrAudio == "audio")
        );
        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
            validFileRecords
        );
        if (validFileRecords.length != fileRecordsNewlySelected.length) {
            this.showUploadError = true;
        } else this.showUploadError = false;
    }

    public startDelete(fileRecord: FileRecord) {
        this.fileRecordToDelete = fileRecord;
        this.deleteDialogActive = true;
    }
    public onBeforeDelete(confirmation: boolean) {
        if (this.fileRecordToDelete) {
            const i = this.fileRecordsForUpload.indexOf(
                this.fileRecordToDelete
            );
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                const k = this.fileRecords.indexOf(this.fileRecordToDelete);
                if (k !== -1) this.fileRecords.splice(k, 1);
            } else {
                if (confirmation) {
                    this.agent.deleteFileRecord(this.fileRecordToDelete); // will trigger 'delete' event
                }
            }
            this.fileRecordToDelete = null;
            this.deleteDialogActive = false;
        }
    }
    public async fileDeleted(fileRecord: FileRecord) {
        if (fileRecord.upload.data) {
            fileRecord.urlValue =
                "/api/file/by_id/" + fileRecord.upload.data.id;
        }

        const i: number = this.fileRecordsForUpload.indexOf(fileRecord);
        if (i !== -1) {
            this.fileRecordsForUpload.splice(i, 1);
        } else {
            if (!fileRecord.error) {
                this.deleteUploadedFile(fileRecord);
            }
        }
    }
    public onUpload(event: { data: {}; fileRecord: FileRecord }[]) {
        event.forEach(e => {
            let size = "";
            // search if a video size is in the name
            this.videoSizes.forEach(vs => {
                if (
                    e.fileRecord.name().includes(vs) &&
                    this.videoOrAudio == "video"
                ) {
                    size = this.videoSizes[this.videoSizes.indexOf(vs)];
                }
            });
            if (size != "") {
                this.sources.push({
                    type: e.fileRecord.file.type,
                    size: size.slice(0, -1), // remove "p"
                    src:
                        "/api/file/stream/by_id/" + e.fileRecord.upload.data.id,
                });
            } else
                this.sources.push({
                    type: e.fileRecord.file.type,
                    src:
                        "/api/file/stream/by_id/" + e.fileRecord.upload.data.id,
                });
        });
    }
}
